import Pages from './Pages/Pages';

function App() {
  return (
    <div className="App">
      <Pages />
    </div>
  );
}

export default App;
